import React from "react";

export default function Layout({ children }) {
  return <div className="auth">{children}</div>;
}
